import { reviews } from '@/mocks/home';

export default function Reviews() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            用户真实评价
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            来自各行业用户的真实反馈，看看他们怎么说 17c
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.slice(0, 3).map((review) => (
            <div
              key={review.id}
              className="p-6 rounded-lg bg-background-100 border border-background-200/60 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < review.rating ? 'ri-star-fill text-primary-500' : 'ri-star-fill text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5 flex-1">
                "{review.content}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{review.name}</div>
                  <div className="text-xs text-foreground-500">{review.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {reviews.length > 3 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            {reviews.slice(3, 5).map((review) => (
              <div
                key={review.id}
                className="p-6 rounded-lg bg-background-100 border border-background-200/60 flex flex-col"
              >
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-sm ${i < review.rating ? 'ri-star-fill text-primary-500' : 'ri-star-fill text-background-300'}`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-5 flex-1">
                  "{review.content}"
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">{review.name}</div>
                    <div className="text-xs text-foreground-500">{review.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}